/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

export default freeGlobal;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/lodash-es/_freeGlobal.js
// module id = ../../../../lodash-es/_freeGlobal.js
// module chunks = 3